import { html } from "lit-html";
import { Base } from "@escapio/shared/components/dialogs/Base";
import { data } from "@escapio/shared/state/payload";
import { translate } from "@escapio/shared/l10n/translate";
import { setSignedUp } from "@escapio/portal/components/newsletter/popupTracker";
import checkmarkSvg from "@docroot/public/img/linearicons/checkmark.svg";
import "../form/Validator";
import "../form/CheckboxDependentField";

export class DirectContactDialog extends Base {
	constructor(dialogOpener) {
		super();
		this.node.classList.add(
			"dialog--popup-desktop",
			"direct-contact-dialog",
			"font-size-base",
		);
		this.hotelId = dialogOpener.getAttribute("hotel-id");
		this.hotelName = dialogOpener.getAttribute("hotel-name");
		this.endpoint = dialogOpener.getAttribute("endpoint");
	}

	getTemplateHeaderLeft() {
		return translate("hotel_direct_contact_dialog_header");
	}

	getTemplateContent() {
		return html`<esc-impression-interaction-tracker
			content-name="Direktkontakt"
			content-piece="${this.hotelId} | ${this.hotelName}"
			content-target="#"
		>
			<esc-form-validator one-time-submit @successfulSubmit=${this.onSuccess}>
				<p>${translate("hotel_direct_contact_dialog_form_preamble")}</p>

				<div
					data-form-error-message
					class="hidden message message--colored message--error message--top-space"
				>
					<span
						class="fa fa-exclamation bullit bullit--red message__icon"
					></span>
					<span data-form-error-text-node></span>
				</div>

				<form method="POST" action=${this.endpoint}>
					<input type="hidden" name="hotel_id" value=${this.hotelId} />

					<div
						class="form-validated__input-container form-element--top-spacing"
					>
						<label class="form-validated__label">
							<input type="text" name="name" placeholder=" " />
							<span class="form-validated__label__text"
								>${translate("contact_form_input_names_mandatory")}</span
							>
						</label>
						<div class="form-validated__error" data-form-field-error></div>
					</div>

					<esc-checkbox-dependent-field
						target-selector=".checkbox-dependent-field"
					>
						<label class="form-checkbox form-element--top-spacing">
							<input
								type="checkbox"
								name="callback"
								placeholder=${translate("contact_form_input_ringback_optional")}
								value="1"
								class="form-checkbox__input"
							/>
							<span class="form-checkbox__label"
								>${translate("contact_form_input_ringback_optional")}</span
							>
						</label>

						<div
							class="form-validated__input-container checkbox-dependent-field form__element--hidden"
						>
							<label class="form-validated__label">
								<input
									type="tel"
									name="phone"
									placeholder=" "
									data-depends-on="callback"
								/>
								<span class="form-validated__label__text"
									>${translate("contact_form_input_telephone")}</span
								>
							</label>
							<div class="form-validated__error" data-form-field-error></div>
						</div>
					</esc-checkbox-dependent-field>

					<div
						class="form-validated__input-container form-element--top-spacing"
					>
						<label class="form-validated__label">
							<input type="email" name="email" placeholder=" " />
							<span class="form-validated__label__text"
								>${translate("contact_form_input_email_mandatory")}</span
							>
						</label>
						<div class="form-validated__error" data-form-field-error></div>
					</div>

					<div
						class="form-validated__input-container form-element--top-spacing"
					>
						<label class="form-validated__label">
							<textarea rows="3" name="message" placeholder=" "></textarea>
							<span class="form-validated__label__text"
								>${translate("contact_form_input_message_mandatory")}</span
							>
						</label>
						<div class="form-validated__error" data-form-field-error></div>
					</div>

					<div>
						<label class="form-checkbox form-element--top-spacing">
							<input
								type="checkbox"
								name="subscribe_to_newsletter"
								value="1"
								class="form-checkbox__input"
							/>
							<span class="form-checkbox__label">
								<span>
									${translate(
										"direct_contact_form_newsletter_checkbox_label",
									)}&nbsp;<a
										href=${data.uris["newsletter-subscription"]}
										class="text--green"
										target="_blank"
										>${translate("newsletter_banner_tos_info_link_label")}</a
									>.
								</span>
							</span>
						</label>
						<div class="form-validated__error" data-form-field-error></div>
					</div>

					<p class="form-element--top-spacing font-size-small">
						${translate("contact_form_data_privacy_notice")} (<a
							class="text--green"
							href=${data.uris["corp-page-privacy_policy"]}
							>${translate("contact_form_data_privacy_link")}</a
						>).
					</p>
					<button
						class="action-button action-button--loader form-element--top-spacing button--align-right"
					>
						${translate("basic_send")}
					</button>
				</form>

				<div
					class="hidden message message--success message--colored"
					data-form-success-message
				>
					<span class="bullit bullit--green message__icon"
						>${checkmarkSvg}</span
					>
					<span>${translate("basic_form_successful")}</span>
				</div>
			</esc-form-validator>
		</esc-impression-interaction-tracker>`;
	}

	onSuccess() {
		const hasNewsletterSubscription = this.node.querySelector(
			'input[name="subscribe_to_newsletter"]',
		).checked;
		if (hasNewsletterSubscription) {
			setSignedUp();
		}
	}
}
